import React from 'react';
import classNames from 'classnames';

import TableHead from './TableHead';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { TableHeadCell } from './HeadCell';
import TableBody from './TableBody';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CellDescription, BodyItem } from './BodyCell';

export interface TableProps {
  columns: TableHeadColumns[];
  body: BodyItem[];
  enableRowHeader?: boolean;
  title?: string;
}

export type TableHeadColumns = CellDescription & TableHeadCell;

const Table: React.FC<TableProps> = ({
  title,
  columns = [],
  body = [],
  enableRowHeader = true,
}) => (
  <table
    className={classNames(
      'ui-table',
      (enableRowHeader && 'ui-table--with-head') || 'ui-table--headless'
    )}
  >
    <caption className="ui-table-hidden-description">{title}</caption>
    {enableRowHeader && <TableHead columns={columns} />}
    <TableBody itemMap={columns} body={body} />
  </table>
);

export default Table;
